import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@dru/ui';
import { AuthProvider } from './lib/auth';
import { AppRouter } from './app/router';
import { registerServiceWorker } from './pwa/register';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      {/* The theme belongs to the device, not the session: a worker who set
          dark on their phone keeps it across the OTP screen and after signing
          out. */}
      <ThemeProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);

// After render: the shell precache must not compete with the first paint on
// a 3G handset, which is this app's ordinary first visit.
registerServiceWorker();
